
import axios from 'axios'

export default {
    getUploadToken({commit}, params){
        return axios.post('/api/background/oss/upload_token/get', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/file.js